import { Box, chakra, keyframes, Spinner, Stack, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import Header from '../../../../../components/Header/Header';
import { useRequestMyExemption } from '../../../../../services/hooks/CandidateArea/useRequestMyExemption';
import ListSolicitationExemption from './listSolicitation';
import MessageBox from '../../../Resources/mobile/create/message';
import CardHeaderMobile from '../../../../../components/Mobile/header';
import AlertMobile from '../../../../../components/Mobile/alert';

interface IOwnProps {}

const floatIn = keyframes`
      from { opacity: 0; transform: translateY(18px) scale(0.995); }  
  `;

const AnimatedBox = chakra(Box, {
  baseStyle: {
    animation: `${floatIn} 420ms cubic-bezier(.2,.9,.3,1) both`,
  },
});

const ExemptionMobilePage: React.FC<IOwnProps> = () => {
  const bgGradient = useColorModeValue('linear(to-br, gray.50, white)', 'linear(to-br, gray.900, gray.800)');
  const borderColor = useColorModeValue('gray.100', 'gray.700');

  const { data, isLoading } = useRequestMyExemption();

  return (
    <Stack height="100%" w="100%" top={0} bg="white" gap={0}>
      <Header />
      <VStack mt={0} flex={1} overflowX="hidden" py={1} px={3} gap={data && data[0].exemption_confirmation ? 2 : 0}>
        {data && data.length > 0 && data[0].exemption_confirmation && (
          <AlertMobile title="Informação para isenção">{data[0].exemption_confirmation || ''}</AlertMobile>
        )}
        {(isLoading && (
          <VStack flex={1} w="100%" justify="center">
            <Spinner emptyColor="gray.100" color="blue.500" size="xl" />
            <Text fontSize="sm">Buscando isenções disponiveis...</Text>
          </VStack>
        )) || (
          <AnimatedBox
            bgGradient={bgGradient}
            borderRadius="lg"
            boxShadow="lg"
            w="100%"
            p={{ base: 5, md: 10 }}
            borderWidth={'1px'}
            borderColor={borderColor}
            bg="white"
            flex={1}
            display="flex"
          >
            <VStack boxSizing="border-box" maxW="lg" w="100%" spacing={4} align="stretch">
              <CardHeaderMobile
                title="Solicitação de isenções"
                subTitle="Selecione o processo seletivo desejado. Em seguida, serão exibidos as isenções já solicitadas."
                gap={1}
                px={3}
              />
              <VStack spacing={4} align="stretch" h="100%">
                {(data && data.length > 0 && <ListSolicitationExemption data={data} />) || (
                  <MessageBox title="Nenhuma isenção solicitada">
                    Você ainda não fez nenhuma solicitação de isenção. Assim que enviar, elas aparecerão aqui.
                  </MessageBox>
                )}
              </VStack>
            </VStack>
          </AnimatedBox>
        )}
      </VStack>
    </Stack>
  );
};

export default ExemptionMobilePage;
